var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOwnerStatusModeration = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M2.5 8c0-3.036 2.464-5.5 5.5-5.5s5.5 2.464 5.5 5.5-2.464 5.5-5.5 5.5A5.5 5.5 0 0 1 2.5 8M8 3.5a.5.5 0 0 1 .5.5v4H11a.5.5 0 0 1 0 1H8a.5.5 0 0 1-.5-.5V4a.5.5 0 0 1 .5-.5",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 1.5A6.5 6.5 0 0 0 1.5 8c0 3.589 2.911 6.5 6.5 6.5s6.5-2.911 6.5-6.5S11.589 1.5 8 1.5M2.5 8c0-3.036 2.464-5.5 5.5-5.5s5.5 2.464 5.5 5.5-2.464 5.5-5.5 5.5A5.5 5.5 0 0 1 2.5 8",
  clipRule: "evenodd"
})));
export default SvgIconOwnerStatusModeration;